import { Form, Row, Col, Space, DatePicker, Input, Select } from "antd";
import { Card, Button } from "../../../components/Common";

const { RangePicker } = DatePicker;
const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const LogsFilters = ({
  search,
  onSearchChange,
  range,
  onRangeChange,
  onApply,
  onReset,
  pageSize,
  onPageSizeChange,
  loading,
}) => {
  return (
    <Card>
      <Form layout="vertical" onFinish={onApply}>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} md={8}>
            <Form.Item label="Date range" style={{ marginBottom: 12 }}>
              <RangePicker
                value={range}
                onChange={(value) => onRangeChange(value || null)}
                style={{ width: "100%" }}
                allowEmpty={[true, true]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item label="Search" style={{ marginBottom: 12 }}>
              <Input
                placeholder="API key or endpoint"
                value={search}
                onChange={(event) => onSearchChange(event.target.value)}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={4}>
            <Form.Item label="Page size" style={{ marginBottom: 12 }}>
              <Select
                value={pageSize}
                onChange={(value) => onPageSizeChange(value)}
                options={PAGE_SIZE_OPTIONS.map((value) => ({
                  value,
                  label: `${value} / page`,
                }))}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={4}>
            <Form.Item label=" " colon={false} style={{ marginBottom: 0 }}>
              <Space wrap>
                <Button htmlType="submit" variant="primary" loading={loading}>
                  Apply
                </Button>
                <Button variant="secondary" htmlType="button" onClick={onReset} disabled={loading}>
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default LogsFilters;
